/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) TrashCanIcon Icon component.
 */
export const TrashCanIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none'>
      <path d='M16.9671 9.08984V19.4787C16.9671 19.7549 16.7433 19.9787 16.4671 19.9787H8.13379C7.85765 19.9787 7.63379 19.7549 7.63379 19.4787V9.08984'
        stroke={iconColor}
        strokeWidth='1.5'
        strokeMiterlimit='10' />
      <path d='M6.07812 6.98047H18.5226' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' />
      <path d='M9.9668 5.98047L14.6335 5.98047' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' />
    </svg>
  );
};
export default TrashCanIcon;
